import { useLocation } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore.js'
import { hasUstsAutoProjectAccess } from '../../features/auto-projects/utils/organizationAccess.js'
import AnnouncementsBell from '../announcements/AnnouncementsBell.jsx'
import NotificationsMenu from '../notifications/NotificationsMenu.jsx'
import { navItemFor } from './navigation.js'

/** En-tête de page (titre + phrase d'explication) à la place de l'ancienne barre du haut. */
export default function PageHeader() {
  const { pathname } = useLocation()
  const user = useAuthStore((state) => state.user)
  const item = navItemFor(pathname)

  return (
    <header className="flex flex-wrap items-end justify-between gap-x-6 gap-y-3">
      <div className="min-w-0 max-w-[66ch]">
        <h1 className="text-[26px] font-bold leading-tight tracking-[-0.7px] text-ink">{item?.title ?? 'Jean Louis'}</h1>
        {item?.subtitle && <p className="mt-1.5 text-sm text-foreground-secondary">{item.subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">
        <AnnouncementsBell />
        {hasUstsAutoProjectAccess(user) && <NotificationsMenu />}
      </div>
    </header>
  )
}
